import {Component, OnInit, Input } from '@angular/core';
import { NewlandScannerModel } from '../newland-scanner.model';
import { AbstractWorkflowResultComponent } from '../../@core/abstract-workflow-result.component';

@Component({
    selector: 'abw-newland-scanner-result',
    templateUrl: './newland-scanner-result.component.html',
    styleUrls: ['./newland-scanner-result.component.scss']
})
export class NewlandScannerResultComponent extends AbstractWorkflowResultComponent<NewlandScannerModel> {
}